// src/ui/Switch.jsx
import React from 'react';
import clsx from 'clsx';

export default function Switch({ checked, onChange, className, ...props }) {
  return (
    <div
      role="switch"
      aria-checked={checked}
      onClick={() => onChange?.(!checked)}
      className={clsx(
        'inline-flex items-center rounded-full px-0.5 py-0.5 transition-colors cursor-pointer',
        'w-10 h-5',
        checked
          ? 'bg-[var(--mudo-primary)]'
          : 'bg-[var(--mudo-bg-soft)] border border-[var(--mudo-border)]',
        className
      )}
      {...props}
    >
      <span
        className={clsx(
          'h-4 w-4 rounded-full bg-white shadow-sm transition-transform',
          checked ? 'translate-x-5' : 'translate-x-0'
        )}
      />
    </div>
  );
}
